// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'visa',
  icon: [
    29,
    19,
    null,
    null,
    null,
    <g id="visa" fillRule="nonzero" key="visa">
      <path
        d="M26.58,19 L2.42,19 C1.78347383,19.0053265 1.17090452,18.7575644 0.717061656,18.311223 C0.263218789,17.8648817 0.00528228465,17.2565265 0,16.62 L0,2.38 C0.00528228465,1.74347346 0.263218789,1.13511831 0.717061656,0.688776978 C1.17090452,0.242435646 1.78347383,-0.00532648787 2.42,4.4408921e-16 L26.58,4.4408921e-16 C27.2165262,-0.00532648787 27.8290955,0.242435646 28.2829383,0.688776978 C28.7367812,1.13511831 28.9947177,1.74347346 29,2.38 L29,16.63 C28.9835257,17.9515828 27.9016388,19.0111167 26.58,19 Z"
        id="shape"
        fill="#F6F9FC"
      />
      <path
        d="M0,16 L0,16.63 C0.0164743165,17.9515828 1.09836125,19.0111167 2.42,19 L26.58,19 C27.2165262,19.0053265 27.8290955,18.7575644 28.2829383,18.311223 C28.7367812,17.8648817 28.9947177,17.2565265 29,16.62 L29,16 L0,16 Z"
        id="shape"
        fill="#F99F1B"
      />
      <path
        d="M0,3 L0,2.37 C0.0164743165,1.04841717 1.09836125,-0.011116723 2.42,-2.66469789e-16 L26.58,-2.66469789e-16 C27.2165262,-0.00532648787 27.8290955,0.242435646 28.2829383,0.688776978 C28.7367812,1.13511831 28.9947177,1.74347346 29,2.38 L29,3 L0,3 Z M13.9,6.12 L12.42,12.89 L10.65,12.89 L12.11,6.12 L13.89,6.12 L13.9,6.12 Z M21.37,10.5 L22.31,7.95 L22.85,10.5 L21.37,10.5 Z M23.36,12.9 L25,12.9 L23.56,6.12 L22.05,6.12 C21.717335,6.11239015 21.414695,6.31149546 21.29,6.62 L18.62,12.89 L20.49,12.89 L20.86,11.89 L23.14,11.89 L23.36,12.89 L23.36,12.9 Z M18.72,10.68 C18.72,8.9 16.21,8.8 16.22,8 C16.23,7.76 16.47,7.5 16.98,7.43 C17.5796084,7.37323391 18.1835348,7.47676416 18.73,7.73 L19.04,6.3 C18.62,6.15 18.07,6 17.38,6 C15.62,6 14.38,6.92 14.38,8.24 C14.37,9.21 15.26,9.76 15.93,10.08 C16.63,10.41 16.86,10.63 16.86,10.92 C16.85,11.38 16.3,11.58 15.79,11.58 C14.89,11.6 14.38,11.35 13.97,11.16 L13.64,12.64 C14.06,12.83 14.83,12.99 15.62,13 C17.49,13 18.71,12.1 18.72,10.68 Z M11.35,6.12 L8.47,12.9 L6.6,12.9 L5.18,7.5 C5.09,7.17 5.01,7.05 4.75,6.9 C4.1921685,6.63915717 3.60444617,6.44772761 3,6.33 L3.04,6.13 L6.07,6.13 C6.45,6.13 6.8,6.39 6.89,6.83 L7.64,10.74 L9.49,6.14 L11.35,6.14 L11.35,6.12 Z"
        id="shape"
        fill="#2D4990"
      />
    </g>,
  ],
})
